import { render, staticRenderFns } from "./Nopage.vue?vue&type=template&id=5af76742&scoped=true"
import script from "./Nopage.vue?vue&type=script&lang=js"
export * from "./Nopage.vue?vue&type=script&lang=js"
import style0 from "./Nopage.vue?vue&type=style&index=0&id=5af76742&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af76742",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
